import { render, staticRenderFns } from "./indexKj.vue?vue&type=template&id=c88000de"
import script from "./indexKj.vue?vue&type=script&lang=js"
export * from "./indexKj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports